(() => {
  if (window.__acCollectionLoaded) return;
  window.__acCollectionLoaded = true;

  document.documentElement.classList.add('ac-collection-js');

  const setLoading = (button, loading) => {
    if (!button) return;
    button.classList.toggle('is-loading', loading);
    button.setAttribute('aria-busy', loading ? 'true' : 'false');
    if (loading) {
      button.dataset.originalText = button.textContent;
      button.textContent = 'Loading…';
    } else if (button.dataset.originalText) {
      button.textContent = button.dataset.originalText;
      delete button.dataset.originalText;
    }
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-ac-load-more]');
    if (!button) return;

    event.preventDefault();
    if (button.classList.contains('is-loading')) return;

    const href = button.getAttribute('href');
    if (!href) return;

    const wrapper = button.closest('.productgrid--wrapper');
    const currentGrid = wrapper?.querySelector('[data-productgrid-items]');
    if (!wrapper || !currentGrid) return;

    setLoading(button, true);

    try {
      const response = await fetch(href, { credentials: 'same-origin' });
      if (!response.ok) throw new Error(`Collection page request failed: ${response.status}`);

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const nextGrid = doc.querySelector('[data-productgrid-items]');
      if (!nextGrid) throw new Error('Next collection grid not found');

      const fragment = document.createDocumentFragment();
      Array.from(nextGrid.children).forEach((item) => fragment.appendChild(item.cloneNode(true)));
      currentGrid.appendChild(fragment);

      const nextButton = doc.querySelector('[data-ac-load-more]');
      const nextCount = doc.querySelector('[data-ac-load-more-count]');
      const currentCount = wrapper.querySelector('[data-ac-load-more-count]');

      if (currentCount && nextCount) currentCount.textContent = nextCount.textContent;

      if (nextButton) {
        button.setAttribute('href', nextButton.getAttribute('href'));
        setLoading(button, false);
      } else {
        const wrap = button.closest('[data-ac-load-more-wrap]');
        button.remove();
        wrap?.classList.add('ac-collection-load-more--complete');
      }

      document.dispatchEvent(new CustomEvent('ac:collection:products-added', {
        detail: { container: currentGrid }
      }));
    } catch (error) {
      console.error('[AC Collection] Load more failed', error);
      setLoading(button, false);
      window.location.href = href;
    }
  });
})();
